import * as mutationType from "../mutation_types";

const state = {
  tasks: [],
  alerts: []
};

const getters = {
  tasks: state => state.tasks || [],
  alerts: state => state.alerts
};

const actions = {
  getTasks({ commit }) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .get("/api/tasks")
        .then(res => {
          commit(mutationType.SET_TASKS, res.data);
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  getAlerts({ commit }) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .get("/api/tasks/alerts")
        .then(res => {
          commit(mutationType.SET_ALERTS, res.data);
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  }
};

const mutations = {
  [mutationType.SET_TASKS](state, list) {
    state.tasks = list;
  },
  [mutationType.SET_ALERTS](state, item) {
    state.alerts = item;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
